export class DeviceInfoRes{
    id!:string;
    hostOs!:string;
    hwName!:string;
    ipV6?:string;
    ipV4?:string;
    installedOn!:string
    installedOnDate = new Date(this.installedOn)
}

export class DeviceInfoReq{
    hostOs!:string;
    hwName!:string;
    ipV6?:string;
    ipV4?:string;
    installedOn!:string
}